/**
 * SDK cliente del Sistema de Perfiles.
 *
 * Punto ÚNICO de acceso a /api/perfil/* desde el frontend.
 * Ningún componente hace fetch directo: consume este SDK vía hooks/Context.
 * Alineado con Etapa 4 §2.1 (arquitectura de capas).
 */

import { api } from "./api";

/**
 * Bootstrap: bundle inicial Perfil Global + Progreso en una sola llamada.
 * @returns {Promise<{ perfil_global: object, progreso: object }>}
 */
export async function fetchBootstrap() {
  const { data } = await api.get("/perfil/bootstrap");
  return data;
}

export async function fetchPerfilGlobal() {
  const { data } = await api.get("/perfil/global");
  return data;
}

/**
 * Actualiza (parcial) el Perfil Global.
 * @param {object} patch  campos a modificar
 * @param {number} [expectedVersion]  If-Match para concurrencia optimista
 */
export async function updatePerfilGlobal(patch, expectedVersion) {
  const headers = expectedVersion != null
    ? { "If-Match": String(expectedVersion) }
    : undefined;
  const { data } = await api.put("/perfil/global", patch, { headers });
  return data;
}

export async function fetchProgreso() {
  const { data } = await api.get("/perfil/progreso");
  return data;
}

/** Sube el avatar del usuario (multipart) y devuelve el Perfil Global actualizado. */
export async function uploadAvatar(file, onProgress) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/perfil/avatar", form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (evt) => {
      if (onProgress && evt.total) {
        onProgress(Math.round((evt.loaded / evt.total) * 100));
      }
    },
  });
  return data;
}

export async function recomputeProgreso() {
  const { data } = await api.post("/perfil/progreso/recalcular");
  return data;
}

/** Perfil público (proyección sin PII). */
export async function fetchPerfilPublico(userId) {
  const { data } = await api.get(`/perfil/global/${userId}`);
  return data;
}

// ---------------- Módulo 3 — Perfil Profesional multi-rol ----------------

export async function fetchTiposUsuario() {
  const { data } = await api.get("/perfil/tipos-usuario");
  return data;
}

export async function fetchSchema(tipo) {
  const { data } = await api.get(`/perfil/schema/${tipo}`);
  return data;
}

export async function fetchRoles() {
  const { data } = await api.get("/perfil/roles");
  return data;
}

export async function addRol(tipoUsuario) {
  const { data } = await api.post("/perfil/roles", { tipo_usuario: tipoUsuario });
  return data;
}

export async function setRolPrincipal(tipo) {
  const { data } = await api.post(`/perfil/roles/${tipo}/principal`);
  return data;
}

export async function activarRol(tipo) {
  const { data } = await api.put(`/perfil/roles/${tipo}/activar`);
  return data;
}

export async function desactivarRol(tipo) {
  const { data } = await api.put(`/perfil/roles/${tipo}/desactivar`);
  return data;
}

export async function eliminarRol(tipo) {
  await api.delete(`/perfil/roles/${tipo}`);
}

export async function fetchPerfilProfesional(tipo) {
  const params = tipo ? { tipo } : {};
  const { data } = await api.get("/perfil/profesional", { params });
  return data;
}

export async function updatePerfilProfesional(tipo, patch) {
  const { data } = await api.put("/perfil/profesional", patch, { params: { tipo } });
  return data;
}
